export class GeneratingCustomerPulseRequestObject {
  requestNumber: string;
}

export interface GeneratingCustomerPulseResponseObject {
  token: string;
}
